import React, { useState, useEffect } from "react";
import Page from "../Page";
import { Card, CardContent, Typography, Stack } from "@mui/material";
import { CommonSearchbar } from "src/layouts/dashboard/Searchbar";
import ExportCSV from "src/components/ExportCsv/ExportCSV";
import { BaseTable } from "src/components/BaseTable/BaseTable";
import { promoCodeColumns } from "./Promo.constant";
import PromoModal from "./PromoModal";
import { useList } from "src/hooks/useFetch.hook";
import { useMutate } from "src/hooks/useFetch.hook";
import { useSelectedTeam } from "src/hooks/useSelectedTeam";
import { updatePromoCodeStatusUrl } from "src/react-query/endPoints";
import { FEATURE } from "src/util/enums";
import { useAccess } from "src/hooks/useAccess.hook";

const ManagePromoCodes = () => {
  const [promoCodeModalOpen, setPromoCodeModalOpen] = React.useState(false);
  const [selectedPromoCode, setSelectedPromoCode] = React.useState(null);
  const [isViewMode, setIsViewMode] = React.useState(false);
  const { data, isFetching, refetch } = useList("promoCodes");
  const { mutate: updateStatus } = useMutate("updatePromoCodeStatus");
  const { teamId, teamType } = useSelectedTeam();
  const visibility = teamType !== "GP" ? true : false;
  const [promoCodeData, setPromoCodeData] = useState([]);
  const isReadOnly = useAccess(FEATURE.PROMOCODE, "R");
  const handleSearching = (event) => {
    const dataToSearchFrom = data;
    const searchValue = event.target.value.trim().toString().toLowerCase();
    if (searchValue) {
      const filteredDataArr = dataToSearchFrom.reduce(
        (filteredDataArr, currentObj) => {
          const relevantFields = [
            "code",
            "name",
            "discount_type",
          ];
          const allValuesArr = Object.entries(currentObj)
            .filter(([key, value]) => relevantFields.includes(key))
            .map(([key, value]) =>
              key === "creationTime"
                // ? yearFirstDateTimeFormat(value).toString()
                // : value === "Y"
                ? "active"
                : value === "N"
                  ? "inactive"
                  : value
                    ? value.toString().toLowerCase()
                    : ""
            );
          const searchResult = allValuesArr.find((value) =>
            value.includes(searchValue)
          );
          if (searchResult) {
            filteredDataArr = [...filteredDataArr, currentObj];
          }
          return filteredDataArr;
        },
        []
      );
      setPromoCodeData(filteredDataArr);
    } else setPromoCodeData([...data]);
  };

  const handlepromoCodeModalClose = () => {
    setPromoCodeModalOpen(false);
    setSelectedPromoCode(null);
    setIsViewMode(false);
  };

  const handlePromoCodeAction = () => {
    setSelectedPromoCode(null); // For creating new promo code
    setIsViewMode(false);
    setPromoCodeModalOpen(true);
  };

  const handleEditPromoCode = (row) => {
    setSelectedPromoCode(row.id); // For editing existing promo code
    setIsViewMode(false);
    setPromoCodeModalOpen(true);
  };

  const handleViewPromoCode = (row) => {
    setSelectedPromoCode(row.id);
    setIsViewMode(true);
    setPromoCodeModalOpen(true);
  };

  const handleDeletePromoCode = (row) => {
    if (window.confirm(`Are you sure you want to delete promo code "${row.code}"?`)) {
      // Implement delete API call here
      console.log("Delete confirmed for:", row.id);
    }
  };

  const handleStatusChange = (row, newStatus) => {
    const statusText = newStatus ? "activate" : "deactivate";
    if (row) {
      const url = updatePromoCodeStatusUrl(teamId, row.id);
      updateStatus({
        url: url,
        method: "PATCH",
        body: { is_active: newStatus }
      }, { onSuccess });
    }
  };

  const onSuccess = () => {
    refetch();
  };

  const actionHandlers = {
    onEdit: handleEditPromoCode,
    onView: handleViewPromoCode,
    onDelete: handleDeletePromoCode,
    onStatusChange: handleStatusChange,
  };

  const columns = promoCodeColumns(actionHandlers, visibility);

  useEffect(() => {
    if (!isFetching) {
      setPromoCodeData(data);
    }
  }, [isFetching]);

  const pageActions = isReadOnly
    ? undefined
    : [{ path: "/manage-promo-codes/analytics", text: "View Analytics", icon: "mdi:chart-line" }];

  return (
    <Page
      title="Promo Code | Smart-CMS"
      actions={pageActions}
      addCategoryText={!isReadOnly ? "Create Promo Code" : undefined}
      categoryAction={!isReadOnly ? handlePromoCodeAction : undefined}
    >
      <Card sx={{ p: 2 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
          <CommonSearchbar
            placeholder="Search"
            searchFunc={(e) => handleSearching(e)}
          />
          <ExportCSV
            rows={promoCodeData || []}
            columns={columns}
            csvMorphemes="promo_codes"
            csvColumns={columns}
          />
        </Stack>
        <BaseTable
          rows={promoCodeData ?? []}
          columns={columns}
          loading={isFetching}
          getRowId={(row) => row.id}
          pageSize={10}
          showExportCsvBtn={false}
          rowOrCellClickRedirect={handleEditPromoCode}
          isReadOnly={isReadOnly}
          csvColumns={columns}
        />
      </Card>
      <PromoModal
        open={promoCodeModalOpen}
        onClose={handlepromoCodeModalClose}
        editData={selectedPromoCode}
        viewMode={isViewMode}
      />
    </Page>
  );
};

export default ManagePromoCodes;
